(function(){
if(window.__vxcompra)return;window.__vxcompra=1;
function rotulo(){
 document.querySelectorAll('.shopify-payment-button__button,.shopify-payment-button__button--unbranded').forEach(function(b){
  var t=(b.textContent||'').trim();
  if(/concluir compra|comprar agora|buy it now|check ?out/i.test(t)&&t!=='Concluir solicitação'){b.textContent='Concluir solicitação'}});
}
function minimo(){
 document.querySelectorAll('.quantity__input[data-vxmin]').forEach(function(i){
  var m=parseInt(i.dataset.vxmin||'1',10)||1;
  i.min=m;
  if(!i.value||parseInt(i.value,10)<m)i.value=m;
  var menos=i.parentElement.querySelector('[name=minus]');
  function trava(){var v=parseInt(i.value,10)||m;if(v<m){i.value=m;v=m}if(menos)menos.disabled=(v<=m)}
  if(!i.dataset.vxon){i.dataset.vxon='1';i.addEventListener('change',trava);i.addEventListener('input',trava);
   if(menos)menos.addEventListener('click',function(){setTimeout(trava,0)});}
  trava();});
}
function preco(){
 var alvo=document.querySelector('[data-vxpreco]');if(!alvo)return;
 if(document.querySelector('[data-vxde]'))return;
 var src=document.querySelector('#price-'+(document.querySelector('[data-section]')||{}).dataset?.section)||document.querySelector('.price__container .price-item--sale,.price-item--regular');
 if(!src)return;
 var t=(src.textContent||'').replace(/\s+/g,' ').trim();
 var m=t.match(/R\$\s?[\d.,]+/);
 if(m)alvo.textContent=m[0].replace(/\s/,' ');
}
function whats(){
 var a=document.querySelector('[data-vxwa]');if(!a)return;
 var op=[...document.querySelectorAll('.product-form__input input:checked,.product-form__input select')]
   .map(function(e){return e.tagName==='SELECT'?e.value:e.value}).filter(Boolean);
 var chip=document.querySelector('[data-vxchip-maq]');
 if(chip&&document.querySelector('[data-vxchip-on]')&&document.querySelector('[data-vxchip-on]').checked)op.push('chip para '+chip.value);
 var q=document.querySelector('.quantity__input');
 var msg='Olá! Tenho interesse no '+a.dataset.vxwaProd+(op.length?' · '+op.join(' · '):'')+(q&&q.value?' · quantidade '+q.value:'')+' — '+a.dataset.vxwaUrl;
 a.href=a.dataset.vxwaBase+encodeURIComponent(msg);
}
function tudo(){rotulo();minimo();preco();whats();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',tudo);else tudo();
document.addEventListener('change',function(e){if(e.target.closest('.product-form__input,[data-vxchip],.quantity'))setTimeout(tudo,80)});
document.addEventListener('shopify:section:load',tudo);
new MutationObserver(function(){rotulo();preco()}).observe(document.documentElement,{childList:true,subtree:true});
})();
